export enum NavigationStates {
	ENABLED = 'enabled',
	DISABLE_NEXT = 'disable_next',
	HIDDEN = 'hidden',
	ONLY_FORWARD = 'only_forward',
	ONLY_BACKWARD = 'only_backward',
	NEXT_HIDDEN = 'next_hidden',
}
